import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as SlotsPropertiesActions from "../../store/actions/Slots";

const instructions = [
  "Slot Compliance will be exempted",
  "Star Gigs if exist for the given slot capacity, then it will be exempted",
  "We can revert the above exemptions by passing the exemptions flag as false",
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const SlotsBulkUpload = ({ getBulkUploadUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="slotsBulkUploadBtn"
      uploadUrl="/driver-shift/slot/bulk-update-slot-daily-capacity/ack"
      sampleURL="/sample/bulk_update_slot_daily_capacity.csv"
      id="bulkUpdateSlotDetailsModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Gigs exemption upload (Slot)"
      getUploadUrl={getBulkUploadUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      SlotsPropertiesActions.getBulkUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(SlotsBulkUpload);
